import { Article, ArticleCollection, Author, FeaturedArticle, HelpCenter, Widget } from "../../types";
import BaseController from "./BaseController";

class HelpCenterController extends BaseController {
  static getOverview(): Promise<{ help_center: HelpCenter, featured_articles: FeaturedArticle[], article_collections: ArticleCollection[] }> {
    return this.post('messenger/help_center/overview');
  }

  static getCollection(id: string): Promise<{
    help_center: HelpCenter
    article_collection: ArticleCollection;
    authors?: Author[]
    articles_count?: number;
  }> {
    return this.post(`messenger/help_center/collection/${id}`);
  }

  static getArticle(id: string): Promise<{
    help_center: HelpCenter
    article: Article
    related_articles?: Article[]
  }> {
    return this.post(`messenger/help_center/article/${id}`);
  }

  static search(search: string): Promise<Article[]> {
    return this.post('messenger/help_center/search', { search: search });
  }
}

export default HelpCenterController